import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllBanners } from 'redux-thunk/thunk/banner.thunk'

const AppBannerInit = () => {
  const dispatch = useDispatch()
  const { banners, loading } = useSelector((state) => state.banner)

  useEffect(() => {
    if (banners.length === 0 && !loading) {
      dispatch(fetchAllBanners())
    }
  }, [])

  return null;
}

export default AppBannerInit
